/**
 * @format
 * @module ui/user-mobile-modal
 * @description Display interstitial modal on mobile first visit to increase conversions
 */
import tgamConfig from "config/tgam";
import { configureModal, hideAllModals } from "ui/modal-manager";
import { handleJSON, handleRenderFeature, validStatus } from "utils/fetch";
import { isMobile } from "utils/detect";
import { isAnonymous } from "lib/identity/api";
import { local } from "lib/store";
import { getById, getProp } from "utils/utils";
import { constructQuery } from "utils/urls";
import { API_PB_RENDER_FEATURE } from "lib/gamservices";
import values from "lodash/values";
import logger from "utils/logger";

const debugTag = "[USER-MOBILE-MODAL]";
const mobileModalWasDisplayedLocalStorage = "tgam.mobile-modal-first-visit";

/**
 * Determine if the modal should be displayed on the current section or article
 * @param {String} sections - sections
 * @returns {Boolean}
 */
function isValidPath(sections) {
  const url = tgamConfig.meta.urlRelative;
  if (!url) {
    return false;
  }
  if (sections === "*") {
    return true;
  }
  const isValid = sections.split(",").filter(path => url.includes(path)).length > 0;
  return isValid;
}

/**
 * Render modal's markup
 * @param {String} html - markup
 * @param {Boolean} forceModal
 */
function renderModal(html, forceModal) {
  logger.info(`${debugTag} Show modal`);
  const showModal = configureModal({
    uid: "user-mobile-modal",
    templates: [html],
    width: "450",
    height: "auto"
  });

  showModal();

  const closeButton = getById("js-mobile-modal-close");
  closeButton &&
    closeButton.addEventListener("click", () => {
      logger.info(`${debugTag} Close modal`);
      hideAllModals();
    });

  if (!forceModal) {
    setTimeout(() => hideAllModals(), 5000);
  }
  local.set(mobileModalWasDisplayedLocalStorage, true);
}

/**
 * Display a dismissable modal for anonymous users
 */
export default function init() {
  logger.info(`${debugTag} Init`);
  const isAdv = getProp(tgamConfig, "meta.advContent", false);
  const modalSections = getProp(tgamConfig, "env.mobileModalSections", "");
  const modalWasDisplayed = local.get(mobileModalWasDisplayedLocalStorage) || false;
  const conditions = {
    firstVisit: !modalWasDisplayed,
    modalEnabled: modalSections.length > 0,
    isValidSection: isValidPath(modalSections),
    mobile: isMobile(),
    anonymous: isAnonymous(),
    isNotADV: !isAdv
  };
  logger.info(`${debugTag} User mobile modal conditions`, conditions);
  const displayModal = values(conditions).every(item => item === true);
  const forceModal = /userModal=true/.test(window.location.search);
  if (displayModal || forceModal) {
    const query = constructQuery(
      {
        uri: "/zzz_darwin-test_zzz/",
        name: "user-mobile-modal"
      },
      true
    );
    const pbRenderAPI = `${API_PB_RENDER_FEATURE}?${query}`;
    fetch(pbRenderAPI)
      .then(validStatus)
      .then(handleJSON)
      .then(handleRenderFeature)
      .then(html => renderModal(html, forceModal))
      .catch(() => {
        logger.info(`${debugTag} mobile modal failed to load`);
      });
  }
}
